import React from 'react';
import { Card, CardProps } from '@/components/Card/Card';

export type GlassCardTone = 'neutral' | 'daily';

export interface GlassCardProps extends Omit<CardProps, 'color'> {
  tone?: GlassCardTone;
}

const TONE_CLASS_MAP: Record<GlassCardTone, string> = {
  neutral: 'glass-keylight bg-neutral/50',
  daily: 'glass-keylight bg-daily/50',
};

/**
 * Shared frosted-glass surface for homepage-style cards.
 *
 * This keeps the glass tint, shadow, and border treatment together so callers
 * only provide layout/content classes instead of rebuilding the surface ad hoc.
 */
export const GlassCard: React.FC<GlassCardProps> = ({
  tone = 'neutral',
  className = '',
  children,
  ...props
}) => {
  return (
    <Card
      color={tone === 'daily' ? 'daily' : 'neutral'}
      className={`${TONE_CLASS_MAP[tone]} ${className}`.trim()}
      {...props}
    >
      {children}
    </Card>
  );
};
